/** 
* @title: Show More/Less
* @description: Show More/Less when clicking link
*/

function showHide() {
    
    const showButtons = document.querySelectorAll('[data-show-button]');
        
    for (const b of showButtons) {
        
        b.addEventListener('click', function() {
            const showList = document.querySelector('[data-hidden-list="' + b.dataset.showButton + '"]');
            showList.classList.toggle('d-none');
            
            if (b.innerHTML.trim() == 'More') {
                b.innerHTML = 'Less';
            } else {
                b.innerHTML = 'More';
            }
        });
       
    }
        
        
/*
    
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var btnText = document.getElementById("myBtn");
    
    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
*/
}   

export default showHide;